import { AuditLogPage } from '@/page/audit-log/audit-log';
import { DashboardPage } from '@/page/dashboard/dashboard';
import {
  PrFindingsPage,
  RepositoryFindingsPage,
  validateFindingsSearch,
} from '@/page/findings/findings';
import { GovernancePage } from '@/page/governance/governance';
import { McpPage } from '@/page/mcp/mcp';
import { SettingsPage } from '@/page/settings/settings';

export const auditLogRouteOptions = {
  component: AuditLogPage,
};

export const dashboardRouteOptions = {
  component: DashboardPage,
};

export const findingsRouteOptions = {
  component: RepositoryFindingsPage,
  validateSearch: validateFindingsSearch,
};

export const pullRequestsRouteOptions = {
  component: PrFindingsPage,
  validateSearch: validateFindingsSearch,
};

export const governanceRouteOptions = {
  component: GovernancePage,
};

export const mcpRouteOptions = {
  component: McpPage,
};

export const settingsRouteOptions = {
  component: SettingsPage,
};
